import {defineSlotRecipe} from '@chakra-ui/react3'

const productAnimatedModuleRecipe = defineSlotRecipe({
    slots: ['container', 'stickyContainer', 'stickyBox', 'textBox', 'productBox', 'textContent'],
    base: {
        container: {
            px: {base: 0, s: 'spacing-90'},
            '--padding-bottom': {base: 0, s: 'spacing.spacing-128'},
            pb: 'var(--padding-bottom, 0px)'
        },
        stickyContainer: {
            w: '100%',
            h: '300vh',
            // compute extra space so the module can fill the screen in case it is smaller
            // use margin so the animation finishes before this spacing start to move away
            mb: 'calc(max(0px, 100vh - var(--content-height, 0px) - var(--header-height, 0px) - var(--padding-bottom)))'
        },
        stickyBox: {
            display: 'flex',
            alignItems: 'center',
            alignContent: 'center',
            position: 'sticky',
            // need to compute where to stick so the whole image is visible in case the screen is small
            // otherwise just stick below the header
            top: 'calc(min(var(--header-height, 0px), 100vh - var(--content-height, 0px)))'
        },
        textBox: {
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        textContent: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-16',
            width: '100%'
        },
        productBox: {
            width: '100%',
            maxWidth: 'calc(100vh - var(--header-height, 132px))',
            aspectRatio: '1/1'
        }
    },
    variants: {
        layout: {
            'side-by-side': {
                container: {
                    '--padding-bottom': '0'
                },
                stickyBox: {
                    flexDirection: {base: 'column', s: 'row'}
                },
                textBox: {
                    w: {base: '100%', s: '50%'},
                    alignItems: 'flex-start',
                    pt: {base: 'spacing-64', s: 'spacing-90'},
                    pr: {base: 'spacing-24', s: 'spacing-90'},
                    pb: {base: 'spacing-48', s: 'spacing-90'},
                    pl: {base: 'spacing-24', s: '0'}
                },
                textContent: {
                    maxWidth: {base: 'auto', s: 409},
                    textAlign: 'left'
                },
                productBox: {
                    w: {base: '100%', s: '50%'}
                }
            },
            'product-below-copy': {
                stickyBox: {
                    flexDirection: 'column'
                },
                textBox: {
                    w: '100%',
                    alignItems: 'center',
                    pt: {base: 'spacing-64', s: 'spacing-128'},
                    pr: {base: 'spacing-24', s: '0'},
                    pb: {base: 'spacing-48', s: 'spacing-40'},
                    pl: {base: 'spacing-24', s: '0'}
                },
                textContent: {
                    maxWidth: {base: 'auto', s: 622},
                    textAlign: {base: 'left', s: 'center'}
                },
                productBox: {
                    w: {base: '100%', s: '630px'}
                }
            }
        },
        motion: {
            full: {
                // full animation - no additonal styles
                stickyContainer: {},
                stickyBox: {}
            },
            reduced: {
                stickyContainer: {
                    h: 'auto',
                    mb: 0
                },
                stickyBox: {
                    position: 'static',
                    top: ''
                }
            }
        }
    }
})

export default productAnimatedModuleRecipe
